function getOptionAnswer(question) {
    let answer = question.answer;
    if (answer) {
        let option = question.options.find((o) => o.id === answer);
        return option.text;
    }
    return null;
}

export { getOptionAnswer };